import { useQuery } from "@tanstack/react-query";
import { appConfigService } from "@/services/app-config";

export function useAppConfig() {
  return useQuery({
    queryKey: ["app-config"],
    queryFn: () => appConfigService.getConfig(),
    staleTime: Infinity,
  });
}
